
import * as utils from '@/components/decorate/decorate-assets/helpers'
let afterLocation = item => ({
    name: [{
        required: true,
        message: '请输入页面名称',
        trigger: 'blur'
    }, ],
    keywords: [{
        required: true,
        message: '请输入关键词',
        trigger: 'blur'
    }, ],
    title: [{
        required: true,
        message: '请输入页面标题',
        trigger: 'blur'
    }],
    expire_start_time: [{
        validator: (rule, value, callback) => {
            if (!item.params ?.expire_start_time || !item.params ?.expire_end_time) {
                callback(new Error('请输入有效期'));
            } else {
                callback();
            }
        },
        trigger: 'blur'
    }],
    expire_time: [{
        validator: (rule, value, callback) => {
            if (!item.params ?.expire_time && item.params ?.expire_time !== 0) {
                callback(new Error('请输入有效期'));
            } else {
                callback();
            }
        },
        trigger: 'blur'
    }],
    limitlevel:[{
        validator: (rule, value, callback) => {
            if (item.params.limitlevel==1&&!item.params.browsepermlevels.length) {
                callback(new Error('请选择会员等级'));
            } else {
                callback();
            }
        },
        trigger: 'blur'
    }],
    limitlabel:[{
        validator: (rule, value, callback) => {
            if (item.params.limitlabel==1&&!item.params.browsepermlabels.length) {
                callback(new Error('请选择会员标签'));
            } else {
                callback();
            }
        },
        trigger: 'blur'
    }]
})
export default (item, $route) => ({
    afterLocation: afterLocation(item),
    beforeLocation(data) {
        if (data) {
            if ($route.params.page === 'goods-detail') {
                if (!data.name) {
                    return new Error('请完善页面设置')
                }
            } else {
                if (!data.name || !data.title) {
                    return new Error('请完善页面设置')
                }
            }
        }
        if (utils.samePath($route.path, '/decorate/poster/followposter')) { //海报装修
            if (!data.keywords || !data.params.expire_end_time || !data.params.expire_start_time || !data.params.expire_time) {
                return new Error('请完善海报设置')
            }
        } else if (utils.samePath($route.path, '/decorate/poster/:page')) { //海报装修
            if (!data.title) {
                return new Error('请完善海报设置')
            }
        } else if($route.path=='/decorate/custom'){
            if(item.params.limitlabel==1&&!item.params.browsepermlabels.length){
                return new Error('请选择会员标签')
            }else if(item.params.limitlevel==1&&!item.params.browsepermlevels.length){
                return new Error('请选择会员等级')
            }
        }
    }
})
